<template>
  <div :class="['box ', { white: !isAtTop }, { bgColor: isColor && isAtTop }]">
    <div v-if="isPC" class="container">
      <img src="@/assets/images/logo.png" alt="logo" width="114px" height="52px" @click="$router.push('/home')" style="margin: 1rem 1rem 0 0" />
      <div class="menu">
        <div class="menu-list">
          <a v-for="item in navList" :key="item.path" class="item" @click="goRoute(item)" @mouseenter="onMouseenter(item)">
            {{ item.name }}
            <img v-if="item.name === '产品系列'" src="../assets/images/down.png" style="width: 20px" alt="" />
          </a>
        </div>
        <!-- 图片插入标题 -->
        <!-- <div v-if="isAtTop" class="menu-items">
          <div v-for="(item, i) in navList" :key="i" @click="handleGo(item)" :class="['item', { active: $route.path === item.path }]">
            {{ item.name }}
          </div>
        </div>

        <div v-else>
          <div class="menu-items">
            <template v-for="(item, i) in navList">
              <img v-if="i === centerIndex" src="@/assets/images/log.png" alt="logo" class="menu-center-image" />
              <div class="item" @click="handleGo(item)">{{ item.name }}</div>
            </template>
          </div>
        </div> -->
      </div>
    </div>

    <div v-else class="container">
      <div class="menu">
        <img src="@/assets/images/Belletu.png" style="position: relative; left: 50%; transform: translateX(-50%)" alt="logo" width="76px" height="18px" />
        <img @click="isMobileMenu = !isMobileMenu" v-if="!isMobileMenu" src="@/assets/images/open-menu.png" height="22px" width="22px" />
        <img @click="isMobileMenu = !isMobileMenu" v-else src="@/assets/images/close-menu.png" height="22px" width="22px" />
      </div>

      <van-popup v-model="isMobileMenu" position="right" :overlay="false">
        <div class="popup-menu">
          <div
            v-for="(item, index) in navList"
            :key="index"
            :class="['popup-menu-item', { 'drop-down': item.path === '/product' && isMobileSonMenu }]"
            :style="{ height: item.path === '/product' && isMobileSonMenu ? `${categories.length * 3}rem` : '3rem' }"
            @click="goRoute(item)"
          >
            <div class="menu-item-left">
              {{ item.name }}
              <!-- 产品子列表 -->
              <template v-if="item.path === '/product' && isMobileSonMenu">
                <div class="son-menu-list">
                  <p @click="goProduct(item.id)" v-for="item in categories" :key="item.id" class="son-item">
                    {{ item.cateName }}
                  </p>
                </div>
              </template>
            </div>
            <span v-if="item.path === '/product'" class="menu-item-right" @click="isMobileSonMenu = !isMobileSonMenu">{{ !isMobileSonMenu ? '+' : '-' }}</span>
          </div>
        </div>
      </van-popup>
    </div>

    <!-- 显示蒙层和产品分类 -->
    <div v-if="showOverlay && categories.length > 0" class="overlay" @mouseleave="onMouseleave">
      <div class="categories-list">
        <a v-for="item in categories" :key="item.id" @click="goProduct(item.id)" class="categories-item">
          {{ item.cateName }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { getProductCategories } from '@/api/index.js'

export default {
  name: 'Nav',
  props: {
    isColor: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      navList: [
        { name: '品牌故事', path: '/home' },
        { name: '产品系列', path: '/product' },
        { name: '品牌加盟', path: '/Business' },
        { name: '最新资讯', path: '/article' },
        { name: '联系我们', path: '/about' }
      ],
      outerWidth: window.innerWidth, // 屏幕宽度
      isAtTop: true, // 滚动条是否在顶部
      isMobileMenu: false, // 移动端菜单是否展开
      isMobileSonMenu: false, // 移动端子菜单是否展开
      categories: [], // 存储产品分类
      showOverlay: false // 控制蒙层显示
    }
  },
  computed: {
    isPC() {
      return this.outerWidth > 768
    },
    centerIndex() {
      return Math.floor(this.navList.length / 2)
    }
  },
  mounted() {
    this.fetchCategories()
    // 初始化
    this.updateOuterWidth()
    this.updateScrollPosition()
    window.addEventListener('resize', this.updateOuterWidth)
    window.addEventListener('scroll', this.updateScrollPosition)
  },
  beforeDestroy() {
    // 清理事件监听
    window.removeEventListener('resize', this.updateOuterWidth)
    window.removeEventListener('scroll', this.updateScrollPosition)
  },
  methods: {
    // 更新 outerWidth
    updateOuterWidth() {
      this.outerWidth = window.innerWidth
    },
    // 更新滚动状态
    updateScrollPosition() {
      this.isAtTop = window.scrollY === 0
    },
    // 路由跳转
    goRoute(item) {
      console.log(item, 11111)

      if (item.path === '/product') return

      this.$router.push({
        path: item.path
      })
    },
    // 产品系列跳转
    goProduct(id) {
      this.$router.push({
        path: `/product`,
        query: { id }
      })
      this.isMobileMenu = false
    },
    // 显示蒙层
    onMouseenter(item) {
      if (item.path === '/product') {
        this.showOverlay = true
      } else {
        this.showOverlay = false
      }
    },
    // 隐藏蒙层
    onMouseleave() {
      this.showOverlay = false
    },
    // 获取产品分类
    async fetchCategories() {
      try {
        const response = await getProductCategories()
        if (response && response.data) {
          this.categories = response.data
        }
      } catch (error) {
        console.error('获取产品分类失败:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  position: fixed;
  top: 0;
  z-index: 100;
  width: 100vw;
  margin: 0 auto;
  &:hover {
    // background-color: #e9f8f5;
    background: rgba(170, 212, 250, 0.1);
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

    @media (max-width: 768px) {
      background-color: #ffffff;
    }
  }
  &.bgColor {
    background: rgba(170, 212, 250, 0.1);
    position: relative;
  }
  &.white {
    margin-top: -68px;
    background-color: #e9f8f5;
    // background: rgba(170, 212, 250, 0.8);
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

    @media (max-width: 768px) {
      position: fixed;
      top: 0;
      height: 4.69rem;
      margin-top: 0;
      background: #ffffff;
    }
  }

  .container {
    width: 80%; // 增加容器宽度
    height: 140px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between; // 使用 space-between 来分配空间
    align-items: center; // 垂直居中对齐

    .menu-center-image {
      display: block;
      margin: 0 auto; /* 居中图片 */
      padding: 1rem 0; /* 可调整上下间距 */
      width: 104px; /* 调整图片宽度 */
      height: auto;
    }
    .menu {
      display: flex;
      align-items: center;
      flex: 1; // 让 logo 部分占据剩余空间

      .menu-list {
        display: flex;
        flex-wrap: nowrap;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* Internet Explorer 10+ */
        font-family: PingFangSC, PingFang SC;
        font-size: 14px;
        color: #000;
        line-height: 20px;
        text-shadow: 1px 1px 0px #ffffff;

        &::-webkit-scrollbar {
          display: none; /* WebKit */
        }
      }
    }

    .item {
      flex: 0 0 auto;
      padding: 0 34px;
      height: 72px;
      line-height: 72px;
      text-align: center;
      cursor: pointer;
      white-space: nowrap;
      transition: color 0.3s;

      &:hover,
      &.active {
        color: #4c88ff;
      }
    }
  }

  .overlay {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: #f4f4f4;
    color: #5d5d5d;
    padding: 1rem;
    z-index: 101;

    .categories-list {
      display: flex;
      flex-direction: column;
      flex-direction: row;
      flex-wrap: wrap;
      // justify-content: space-evenly;

      .categories-item {
        margin: 0.5rem 0;
        padding: 0.5rem;
        border-radius: 4px;
        width: 30%;
        text-align: center;

        &:hover,
        &.active {
          color: #4c88ff;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .container {
      width: 95%;
      height: 75px;
      flex-direction: column;
      align-items: flex-start;
    }

    .menu {
      width: 100%;
      margin-bottom: 10px;
      display: flex !important;
      justify-content: space-between;
    }

    .popup-menu {
      width: 100vw;
      height: 83vh;
      display: flex;
      flex-direction: column;
      background-color: #f2f2f2;

      .popup-menu-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 3rem;
        margin: 0 1rem;
        border-bottom: 1px solid #ececec;

        &.drop-down {
          display: flex;
          align-items: baseline;
        }

        .menu-item-left {
          .son-menu-list {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding: 0 0 0 2rem;

            .son-item {
              margin: 0.5rem 0;
            }
          }
        }

        .menu-item-right {
          font-size: 1.5rem;
        }
      }
    }
  }
}
</style>
